import { native } from '@forest/native-services'
import { enterFrom } from '~/params'

// Dismiss the paywall back to wherever it was opened from. focus-challenge opens
// us by navigating the same WebView via location.href (see ADR 0039), leaving a
// history entry to step back to, so we return there with history.back(). Every
// other entry point opens us as a separate native surface, so we close that
// surface instead. Falls back to close() if there is somehow no history entry to
// return to.
export function returnFromPaywall(): void {
  if (enterFrom === 'focus_challenge' && window.history.length > 1) {
    history.back()
    return
  }
  native.general.close()
}
